import {
  $getSelection,
  $isRangeSelection,
  DELETE_CHARACTER_COMMAND,
} from "lexical";
import React from "react";
import { LexicalProps } from "../LexicalEditor.types";
import { CutIcon } from "../../../assets/icons/SvgIcons";

const Cut = ({ editor, isDropdown }: LexicalProps) => {
  const handleCut = async () => {
    editor.update(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        const selectedText = selection.getTextContent();
        navigator.clipboard
          .writeText(selectedText)
          .then(() => {
            editor.dispatchCommand(DELETE_CHARACTER_COMMAND, true);
          })
          .catch((err) => {
            console.error("Failed to cut text:", err);
          });
      }
    });
  };

  return (
    <div
      onClick={handleCut}
      className={`lexical-toolbarItem ${
        isDropdown ? "lexical-dropdownItem" : ""
      }`}
    >
      <div className="lexical-shortcutWrapper">
        <CutIcon />
        <span className="lexical-shortcutText">Cut</span>
      </div>
      <span className="lexical-shortcut">Ctrl+X</span>
    </div>
  );
};

export default Cut;
